<script>
  export default {
    props: {
      value: String,
      label: String,
      labelWidth: String,
      labelValue: [String, Number],
      labelOptions: Array,
      labelField: String,
      labelDisabled: {
        type: Boolean,
        default: false,
      },
      add: {
        type: Boolean,
        default: false,
      },
      field: String,
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      pickerOptions: {
        type: Object,
        default() {
          return {
            firstDayOfWeek: 1,
          }
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      input_value(v) {
        this.$emit('input', v);
        if (this.field) {
          this.$emit('input-field', {
            field: this.field,
            value: v,
          });
        }
        if (v !== this.value) {
          this.$emit('change', v);
          if (this.field) {
            this.$emit('change-field', {
              field: this.field,
              value: v,
            });
          }
        }
      },
      change_label(v) {
        this.$emit('update:labelValue', v);
        this.$emit('change-label', v);
        if (this.labelField) {
          this.$emit('change-label-field', {
            field: this.field,
            value: v,
          });
        }
      },
      input_label(v) {
        this.$emit('update:labelValue', v);
        if (this.labelField) {
          this.$emit('input-label-field', {
            field: this.field,
            value: v,
          });
        }
      },
      click_add() {
        this.$emit('add');
      },
      blur(v) {
        if (v.userInput !== v.value) v.userInput = v.value;
      }
    },
    computed: {
      show_append() {
        return this.show_add;
      },
      show_add() {
        if (this.disabled) return false;
        return this.add;
      },
    },
    watch: {},
    components: {},
    mounted() {

    },
    destroyed() {

    },
  }
</script>
<template>
  <form-group class="form-date" :label-width="labelWidth" :append="show_append" :label="label||(labelOptions?' ': '')">
    <el-select
      slot="labelSelect"
      v-if="labelOptions"
      :value="labelValue"
      :disabled="labelDisabled"
      @change="change_label"
      @input="input_label">
      <el-option v-for="item in labelOptions"
                 :value="item.value"
                 :label="item.label"
                 :key="item.value">
      </el-option>
    </el-select>
    <el-date-picker
      :value="value"
      @input="input_value"
      @blur="blur"
      type="date"
      format="dd.MM.yyyy"
      value-format="dd.MM.yyyy"
      :clearable="clearable"
      :disabled="disabled"
      :default-value="new Date()"
      :picker-options="pickerOptions">
    </el-date-picker>
    <el-button
      v-if="show_add"
      slot="append"
      icon="el-icon-plus"
      title="Добавить"
      @click="click_add">
    </el-button>
  </form-group>
</template>
<style lang="scss">
</style>
